import React from "react";
import Leaflet from "leaflet";
import { bindActionCreators } from "redux";
import { change } from "redux-form";
import { connect } from "react-redux";
import { FeatureGroup } from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import { dismissToast } from "../layout/actions";
// import geoJsonArea from "@mapbox/geojson-area";
import {
  compose,
  defaultProps,
  withHandlers,
  withStateHandlers
} from "recompose";
import { withTmpField } from "app/proposals/hocs";

import "leaflet-draw/dist/leaflet.draw.css";

const options = {
  draw: {
    circle: false,
    circlemarker: false,
    polyline: false,
    polygon: false,
    rectangle: false,
    marker: false
  },
  edit: {
    remove: false
  }
};

const setOptions = (state, props) => options => {
  return { ...state, ...options };
};

const eventHandlers = {
  onCreated: props => event => {
    // const { setOptions } = props;
    // const draw = { ...props.draw, polygon: false };
    // setOptions({ draw });
    const { change, tmpField, dismissToast } = props;
    const { layer } = event;
    const geometry = layer.toGeoJSON().geometry;
    change("proposal", `tmp.${tmpField.id}.location`, geometry);
    // NOTE commented this out since area is not a predefined input
    // const sqm = geoJsonArea.geometry(geometry);
    // change("proposal", `tmp.${tmpField.id}.inputs.area`, sqm);

    // Dismiss the notification toast
    dismissToast();
  },
  onDeleted: props => event => {},
  onMounted: props => event => {
    const options = {
      // shapeOptions: { color: Colors.GREEN3 }
    };
    var polygonDrawer = new Leaflet.Draw.Polygon(event._map);
    polygonDrawer.setOptions(options);
    polygonDrawer.enable(options);
  },
  onEditStart: props => event => {},
  onEditStop: props => event => {},
  onEdited: props => event => {
    const { change, tmpField } = props;
    const { layers: layerGroup } = event;
    const layers = layerGroup.getLayers();
    if (layers.length > 0) {
      const geometry = layers[0].toGeoJSON().geometry;
      change("proposal", `tmp.${tmpField.id}.location`, geometry);
      // NOTE commented this out since area is not a predefined input
      // const sqm = geoJsonArea.geometry(geometry);
      // change("proposal", `tmp.${tmpField.id}.inputs.area`, sqm);
    }
  },
  onDeleteStart: props => event => {},
  onDeleteStop: props => event => {}
};

const bindActions = dispatch =>
  bindActionCreators({ change, dismissToast }, dispatch);

const enhance = compose(
  defaultProps({
    position: "topright"
  }),
  withStateHandlers(options, { setOptions }),
  connect(
    null,
    bindActions
  ),
  withTmpField,
  withHandlers(eventHandlers)
);

const EditControlGroup = enhance(props => {
  const { children, ...rest } = props;
  return (
    <FeatureGroup>
      <EditControl {...rest} />
      {children}
    </FeatureGroup>
  );
});

export default EditControlGroup;



// WEBPACK FOOTER //
// ./src/app/map/PolygonEditControlGroup.js